import {mapMutations} from "vuex";
import {SHOW_DIALOG} from "@/store/mutations.type";

/**
 * Adds showPalletLogListDialog Method to any component to display a list of logs in a pallet
 */
export default {
	methods: {
		...mapMutations([SHOW_DIALOG]),
		showPalletLogListDialog(pallet) {
			this[SHOW_DIALOG]({
				component: 'PalletLogList',
				fullWidth: true,
				pallet
			});
		}
	}
}